/** The rules handout (`/rules`: basics, roles and cards), in a new tab so the game stays connected. */
export function RulesLink() {
  return (
    <a href="/rules" target="_blank" rel="noopener" data-testid="rules-link">
      The rules
    </a>
  );
}
